import React from 'react';

import type {
  CourseDefinitionQuizQuestionResponse,
  CourseSessionQuizQuestionResponse,
} from 'src/api/ProactApiClient';

import {Button} from '@mantine/core';
import {Divider} from 'src/design/atoms/Divider';
import {Description} from 'src/design/atoms/Description';
import SessionQuestion from './SessionQuestion';

export interface SessionQuizFormProps {
  questions: CourseDefinitionQuizQuestionResponse[];

  sessionQuestions: CourseSessionQuizQuestionResponse[];
  onSessionQuestionsChange: (
    questions: CourseSessionQuizQuestionResponse[]
  ) => void;

  onQuizSubmit: () => void;
}
export const SessionQuizForm: React.FC<SessionQuizFormProps> = ({
  questions,
  sessionQuestions,
  onSessionQuestionsChange,
  onQuizSubmit,
}) => {
  const isQuestionsAnswered =
    sessionQuestions!.filter(
      q =>
        q.answers !== undefined &&
        q.answers.filter(a => a.isSelected === true).length > 0
    ).length > 0;
  const isSubmitEnabled = isQuestionsAnswered === true;
  const submitError =
    isQuestionsAnswered === false
      ? 'Please answer all questions to continue.'
      : '';

  function handleQuestionChange(
    question: CourseSessionQuizQuestionResponse,
    index: number
  ): void {
    const newObjs = Array.from(sessionQuestions);
    newObjs[index] = question;
    onSessionQuestionsChange(newObjs);
  }

  return (
    <>
      {questions.map(question => {
        const sessionQuestion = sessionQuestions.filter(
          q => q.questionDefinitionId === question.id
        )[0];
        const sessionIndex = sessionQuestions.indexOf(sessionQuestion);

        return (
          <React.Fragment key={question.id}>
            <SessionQuestion
              question={question}
              sessionQuestion={sessionQuestion}
              index={sessionIndex}
              onSessionQuestionChange={handleQuestionChange}
            />
            <Divider mt="sm" mb="md" />
          </React.Fragment>
        );
      })}
      <Button disabled={!isSubmitEnabled} onClick={onQuizSubmit}>
        Submit
      </Button>
      <Description mt="md" c="red" text={submitError} />
    </>
  );
};

export default SessionQuizForm;
